<template>
	<v-dialog v-model="openD" :max-width="maxWidth" :persistent="persistent" scrollable>
		<v-card>
			<v-card-title v-if="heading" class="headline" v-html="heading"></v-card-title>
			<v-card-text v-if="message" class="text-xs-justify" v-html="message"></v-card-text>
			<slot name="content"></slot>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
				>
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
  	props: {
        heading: {
            type: String,
			default: ''
		},
        message: {
            type: String,
			default: ''
		},
		maxWidth: {
            type: String,
			default: '500'
		},
        persistent: {
            type: Boolean,
			default: false
		}
	},
    data: () => ({
        openD: false,
        load: false
	}),
	methods: {
		open () {
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
            this.$emit('onClose')
            setTimeout(() => {
                this.load = false
            }, 300)
		}
  	}
}
</script>